/* An optional, user-driven illustration. The real workflow demo remains below. */
document.querySelectorAll('[data-mk-composition]').forEach((composition) => {
  const button = composition.querySelector('[data-mk-composition-toggle]');
  const status = composition.querySelector('[data-mk-composition-status]');
  if (!button || !status) return;
  button.hidden = false;
  button.addEventListener('click', () => {
    const connected = button.getAttribute('aria-pressed') !== 'true';
    button.setAttribute('aria-pressed', String(connected));
    composition.classList.toggle('is-connected', connected);
    button.querySelector('span').textContent = connected ? button.dataset.scatter : button.dataset.connect;
    status.textContent = connected ? status.dataset.after : status.dataset.before;
  });
});
